/**
 * Parallax
 * @description Web component used to create parallax images.
 * @documentation https://simpleparallax.com/
 * @example
<parallax-image>
  <img src="{{- url -}}">
</parallax-image>
 */

(async () => {
  if (!customElements.get('parallax-image')) {
    // The simple parallax module
    const ParallaxModule = await import('simple-parallax-js');
    ParallaxModule;

    class ParallaxImage extends HTMLElement {
      constructor() {
        super();
        this.parallax = this.querySelector('img');

        // Stop when the parallax is not found
        if (!this.parallax) return;

        // Default to improve user experience
        this.parallaxOptions = {};

        // Check if we have extra options on the HTML
        if (this.dataset.options) {
          const options = JSON.parse(this.dataset.options);

          if (options) {
            this.parallaxOptions = {
              ...this.parallaxOptions,
              ...options,
            };
          }
        }

        // Call parallax with selected parallax element and options
        new simpleParallax(this.parallax, this.parallaxOptions);
      }
    }

    window.ParallaxImage = ParallaxImage;

    customElements.define('parallax-image', ParallaxImage);
  }
})();
